@if (data(); as data) {
    <big-ui-alert
        *transloco="let t; prefix: 'errorHandlingAlert'"
        [type]="data.alertType"
        [title]="data?.title ?? t('default.title')">
        <div
            class="w-full"
            [innerHTML]="data?.content ?? t('default.content', {number: phoneNumber.number, title: phoneNumber.title}) | sanitize: securityContext"></div>
    </big-ui-alert>
}
